import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-historic-consumptions-form',
  template: `
    <ng-template #historicConsumptionsForm let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Consumo histórico</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
        <form [formGroup]="historicForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="consumo_lt" class="form-label">Consumo Lt.</label>
            <input type="number" formControlName="consumo_lt" class="form-control" id="consumo_lt" placeholder="">
            <div *ngIf="ufc['consumo_lt'].touched && ufc['consumo_lt'].invalid">
              <div *ngIf="ufc['consumo_lt'].errors?.['required']" class="text-danger text-sm">La clave de la unidad es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="gas_price" class="form-label">Precio</label>
            <input type="number" formControlName="gas_price" class="form-control" id="gas_price" placeholder="">
            <div *ngIf="ufc['gas_price'].touched && ufc['gas_price'].invalid">
              <div *ngIf="ufc['gas_price'].errors?.['required']" class="text-danger text-sm">La clave de la unidad es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="frecuency" class="form-label">Periodo</label>
            <select class="form-select" formControlName="frecuency">
              <option *ngFor="let periodo of periodos" [value]="periodo.id">{{periodo.name}}</option>
            </select>
            <div *ngIf="ufc['frecuency'].touched && ufc['frecuency'].invalid">
              <div *ngIf="ufc['frecuency'].errors?.['required']" class="text-danger text-sm">La clave de la unidad es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="amount" class="form-label">Cantidad</label>
            <input type="number" formControlName="amount" class="form-control" id="amount" placeholder="">
            <div *ngIf="ufc['amount'].touched && ufc['amount'].invalid">
              <div *ngIf="ufc['amount'].errors?.['required']" class="text-danger text-sm">La clave de la unidad es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-4 text-end">
            <button type="submit" class="btn btn-outline-success rounded-3">Guardar</button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class HistoricConsumptionsFormComponent implements AfterViewInit {
  @Input() unit: any;
  @Input() consumption: any;
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>;
  @ViewChild('historicConsumptionsForm') historicConsumptionsForm !: ElementRef;

  historicForm: FormGroup = new FormGroup({});
  private modalRef: NgbModalRef | undefined;

  public periodos: any[] = [
    { id: 1, name: 'Mensual' },
    { id: 2, name: 'Quincenal' },
    { id: 3, name: 'Semanal' }
  ];

  constructor(
    private store: SettlementsService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public icons: IconsService,
  ) { }

  ngAfterViewInit(): void {
    // console.log('CONSUMPTION ==========> ', this.consumption);
    this.initForm();
  }

  initForm() {
    this.historicForm = this.fb.group({
      id: [],
      consumo_lt: ['', Validators.required],
      gas_price: ['', Validators.required],
      frecuency: ['', Validators.required],
      amount: ['', Validators.required],
      unit_id: [],
      receipt: [''],
      bill: [''],
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this['consumption'] && this['consumption'].currentValue) {
      this.historicForm.patchValue(this['consumption'].currentValue);
    }
  }

  get ufc() {
    return this.historicForm.controls;
  }

  onSubmit() {
    console.log('ngSubmit', this.historicForm.value);
    this.historicForm.patchValue({ unit_id: this.unit.id });
    if (this.historicForm.invalid) {
      this.toastr.error('Formulario inválido.', 'Error');
      return;
    }

    if (!this.historicForm.value.id) {
      this.store.createHistoricConsumption(this.historicForm.value).subscribe({
        next: (data: any) => {
          this.dismiss();
        },
        error: (err: any) => {
          console.log(err);
        }
      });
    } else {
      this.store.updateHistoricConsumption(this.historicForm.value.id, this.historicForm.value).subscribe({
        next: (data: any) => {
          this.dismiss();
        },
        error: (err: any) => {
          console.log(err);
        }
      });
    }
  }

  openModal(modalContent: TemplateRef<any>) {
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }

}
